import React, { useState, useCallback, useEffect, useRef } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function WebHookInfo({ handleClose, notification, action, selectedWebhook, refreshList }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    url: '',
    headers: null,
    eventType: '',
    isActive: 'true',
    organizationId: orgId,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();
  const [header, setHeaders] = useState();
  const key = useRef(null);
  const value = useRef(null);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {}, [formData]);
  // useEffect(() => {
  //   getDataForUpdate(`/webhook/${selectedWebhook}`, 'GET');
  // }, []);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/webhook/${selectedWebhook}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...formData,
      headers: header,
    };
    if (action === 'create') postData('/webhook', 'POST', body);
    else updateData(`/webhook/${selectedWebhook}`, 'PATCH', body);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      refreshList();
      notification('success', 'Webhook created successfully');
      handleClose();
    }

    if (isError) {
      notification('error', 'Unable to create webhook detail');
    }
  }, [isLoading, isError, data]);

  // getUser for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData(state.data.webhook);
    }

    if (state.isError) {
      notification('error', 'Unable to fetch webhook detail');
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (state2.data) {
      notification('update', 'Update webhook detail successfully');
      refreshList();
    }

    if (state2.isError) {
      notification('error', 'Unable to update webhook detail');
    }
  }, [state2]);

  const handleAddAttributes = () => {
    const x = { ...header };
    const k = key.current.value;
    const v = value.current.value;

    x[k] = v;
    setHeaders(x);
  };

  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [header]);

  const deleteAttribute = (item) => {
    const attr = { ...header };
    delete attr[item[0]];

    setHeaders(attr);
  };

  useEffect(() => {}, [header]);

  const eventTypes = [
    'BLE_TAG_SEEN_FIRST',
    'BLE_TAG_IN_GATEWAY',
    'BLE_TAG_OUT_GATEWAY',
    'BLE_TAG_GONE_INACTIVE',
    'CATM1_TAG_DATA_AVAILABLE',
  ];
  const is_Active = ['true', 'false'];
  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20  px-16"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-3/4 py-12 px-16 relative mt-10 rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-lg text-textBlue1">{action === 'create' ? 'Create' : 'Edit'} a Webhook</p>

        <form className="mt-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="url" className="block text-parameter w-1/3 text-sm">
              URL
            </label>
            <input
              type="text"
              value={formData.url}
              name="url"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
              EVENT
            </label>
            <input
              name="eventType"
              value={formData.eventType}
              type="text"
              list="event_type"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              onChange={handleInputChange}
            />
            <datalist id="event_type">
              {eventTypes.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </datalist>
          </div>
          <div className="flex w-1/2 items-center my-3.5">
            <label htmlFor="isActive" className="block text-parameter w-1/3 text-sm">
              STATUS
            </label>
            <div className="rounded-lg bg-white px-2 py-3 focus:outline-none text-sm  text-parameter border w-1/2 h-10">
              <select
                name="isActive"
                value={formData.isActive}
                autoComplete="off"
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                <option key="true" value="true" className="fy-4">
                  ACTIVE
                </option>
                <option key="false" value="false" className="fy-4">
                  INACTIVE
                </option>
              </select>
            </div>
          </div>

          <p className="font-black text-base my-3 w-full text-primary">Headers</p>

          <div className="relative flex w-full">
            <div className="flex w-1/2 items-center  my-3.5">
              <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
                KEY
              </label>
              <input
                type="text"
                ref={key}
                className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              />
            </div>

            <div className="flex w-1/2 items-center  my-3.5">
              <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
                VALUE
              </label>
              <input
                type="text"
                ref={value}
                className="rounded-lg bg-white px-4 py-1 focus:outline-none  text-secondary border w-1/2 h-8"
              />
            </div>

            <img
              src="assets/img/Add.svg"
              className="absolute right-3 h-7 top-4 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>
          <div className="w-full flex">
            {header &&
              Object.entries(header).map((item) => (
                <p
                  className="text-black py-1 px-4 rounded-full border mx-2 cursor-pointer"
                  onClick={() => deleteAttribute(item)}
                >
                  {item.join(' - ')}
                </p>
              ))}
          </div>
          <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default WebHookInfo;
